export enum PackageType {
  Standard = "standard",
  BeerAndWineOnly = "beer_wine",
  CustomPackage = "custom_package",
}
export enum PackageSupplies {
  Cups = "cups",
  Garnishes = "garnishes",
  Ice = "ice",
  Mixers = "mixers",
  Napkins = "napkins",
  Straws = "straws",
}
export enum PackageAddonType {
  /**
   * Price is per bartender
   */
  Bartender = "bartender",
  /**
   * Price is a fixed amount
   */
  Fixed = "fixed",
  Guests = "guests",
  Hourly = "hourly",
  NumOfCocktails = "NumOfCocktails",
}
export interface PackageAddon {
  /**
   * Unique ID of the package addon
   */
  id: string;
  /**
   * ID of the package this addon relates to
   */
  packageId: string;
  /**
   * The name of the addon
   */
  name: string;
  /**
   * The description of the addon
   */
  description: string;
  /**
   * The type / pricing method of the addon
   *
   * - PackageAddonType.Bartender - price is per bartender
   * - PackageAddonType.Fixed - price is fixed
   * - PackageAddonType.Guests - price is per 25 guests
   */
  type: PackageAddonType;
  /**
   * The price of the addon (per bartender, fixed, or per 25 guests depending on type)
   */
  price: number;
  cost: number;
  /**
   * Creation timestamp of the package addon
   */
  createdAt: string;
  /**
   * Last updated timestamp of the package addon
   */
  updatedAt: string;
  auto_include: boolean;
  include_prep_time: boolean;
  min_price: number;
}
export interface Package {
  /**
   * Unique ID of the package
   */
  id: string;
  /**
   * ID of the business to which this package belongs
   */
  businessId: string;
  /**
   * The name of the package
   */
  name: string;
  /**
   * The description of the package
   */
  description: string;
  /**
   * The type of package
   */
  type: PackageType;
  /**
   * Package image URL
   */
  image: string | null;
  /**
   * The earliest time events may start (HH:mm:ss)
   */
  startTime: string;
  /**
   * The latest time events may end (HH:mm:ss)
   */
  endTime: string;
  /**
   * The required minimum duration of events in hours
   */
  minHours: number;
  /**
   * The number of minutes before the event that bartenders arrive to set up
   */
  prepMins: number;
  /**
   * The number of guests each bartender can serve (multiple of 25)
   */
  guestsPerBartender: number;
  // guestsPerCocktail: number;
  guestsPerBeer: number;
  is_active :boolean;
  /**
   * 
   * The price per bartender per hour in smallest currency units
   */
  guests_per_bartender:number;
  bartenderPrice: number;
  /**
   * The supplies included in this package
   */
  supplies: PackageSupplies[];
  /**
   * The price of supplies per cocktail in smallest currency units
   */
  suppliesPrice: number;
  /**
   * The fee to charge for delivery (fixed in smallest currency units)
   */
  deliveryFee: number;
  /**
   * The fee per mile of distance (in smallest currency units)
   */
  mileageFee: number;
  /**
   * Whether the collection of tips at the event can be disabled
   */
  tipsOptional: boolean;
  /**
   * The amount of tips to collect per guest if tips are disabled in smallest currency units
   */
  tipsFee: number | null;
  /**
   * Creation timestamp of the package
   */
  createdAt: string;
  /**
   * Last modified timestamp of the package
   */
  updatedAt: string;
  /**
   * Related package addon records
   */
  addons: PackageAddon[] | null;

  bartenderCost: number;
  suppliesCost: number;
  /**
   *  minimum price
   */
  minPrice: number;
  isActive: boolean;
  marketingExpense: number;
  insuranceExpense: number;
  additionalProfit: number;
  isTipPercentage: boolean;
  customSupply?:CustomSupply[];
  minTips:number;
  withPrep?:boolean;
}

// export interface Package {
//     id: string;
//     business_id: string;
//     name: string;
//     description: string;
//     type: string;
//     image: string;
//     start_time: string; // Format "HH:MM:SS"
//     end_time: string;   // Format "HH:MM:SS"
//     min_hours: number;
//     prep_mins: number;
//     guests_per_bartender: number;
//     bartender_cost: number;
//     bartender_price: number;
//     supplies: string[];
//     supplies_cost: number;
//     supplies_price: number;
//     delivery_fee: number;
//     mileage_fee: number;
//     tips_optional: boolean;
//     tips_fee: number;
//     created_at: string; // ISO date string
//     updated_at: string; // ISO date string
//     is_active: boolean;
// }

export interface CustomSupply {
  id: string;
  image: string;
  file?: File;
  name: string;
  type: string;
  cost: number;
  price: number;
  uom: string;
  profit: number;
  isBartender?: boolean;
  isCocktail?: boolean;
  isWine: boolean;
  isBeer: boolean;
  byCustomer: boolean;
  description: string;
  isActive?: boolean;
}